import { render } from "./SearchForm.vue?vue&type=template&id=2ac43a0e"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/library.milim.com/src/public/library/themes/stirtingale/resources/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__